// extracted by mini-css-extract-plugin
module.exports = {"full_width_image_container":"about-module--full_width_image_container--R396w","full_width_header_h1":"about-module--full_width_header_h1--RBl3y"};